import { styled } from '@mui/material/styles';

export const NumericCell = styled('div')`
  text-align: left;
`;
